import { render, staticRenderFns } from "./drawing.vue?vue&type=template&id=dda0b7f0&scoped=true"
import script from "./drawing.vue?vue&type=script&lang=js"
export * from "./drawing.vue?vue&type=script&lang=js"
import style0 from "./drawing.vue?vue&type=style&index=0&id=dda0b7f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dda0b7f0",
  null
  
)

export default component.exports